module.exports = require('./helpers/bundle-url').getBundleURL('73zau') + "logo.7718c6df.svg";